const updates = [
  {
    date: '2026.07.30',
    title: '黑料入口新增"专题合集"功能，支持按事件分类浏览黑料故事',
    tag: '功能更新',
    highlight: true,
  },
  {
    date: '2026.07.28',
    title: '娱乐圈板块更新：某选秀节目导师与选手不正当关系全记录',
    tag: '娱乐圈黑料',
    highlight: false,
  },
  {
    date: '2026.07.26',
    title: '财经圈黑料追踪：某上市公司董事长涉嫌内幕交易被立案调查',
    tag: '财经黑幕',
    highlight: true,
  },
  {
    date: '2026.07.24',
    title: '黑料入口热度榜功能上线，实时反映黑料故事关注度排名',
    tag: '功能更新',
    highlight: false,
  },
  {
    date: '2026.07.22',
    title: '网红圈最新瓜：三大头部主播因利益分配产生裂痕，直播互撕',
    tag: '网红瓜田',
    highlight: true,
  },
  {
    date: '2026.07.20',
    title: '黑料入口读者投稿渠道正式开放，欢迎分享你的独家黑料线索',
    tag: '平台动态',
    highlight: false,
  },
  {
    date: '2026.07.18',
    title: '体育圈争议：某知名运动员涉嫌使用兴奋剂，证据链正在梳理',
    tag: '体育争议',
    highlight: true,
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[800px] mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-50 text-center mb-3">
          最新动态
        </h2>
        <p className="text-sm text-foreground-400 text-center mb-10 md:mb-14">
          黑料入口每日更新快讯，追踪最新黑料故事进展
        </p>
        <div className="relative pl-8 border-l-2 border-background-200/60 space-y-0">
          {updates.map((item, i) => (
            <div key={i} className={`relative pb-8 ${i === updates.length - 1 ? 'pb-0' : ''}`}>
              <div
                className={`absolute -left-[29px] top-1 w-4 h-4 rounded-full border-2 ${
                  item.highlight
                    ? 'bg-primary-500 border-primary-500'
                    : 'bg-background-100 border-background-300'
                }`}
              ></div>
              <div className="ml-2">
                <div className="flex flex-wrap items-center gap-2 mb-1.5">
                  <span className="text-xs text-foreground-500 whitespace-nowrap">{item.date}</span>
                  <span className={`text-xs px-2 py-0.5 rounded-full whitespace-nowrap ${
                    item.highlight
                      ? 'bg-primary-500/15 text-primary-400'
                      : 'bg-background-200 text-foreground-500'
                  }`}>
                    {item.tag}
                  </span>
                </div>
                <h3 className="text-sm md:text-base font-medium text-foreground-200 leading-relaxed">
                  {item.title}
                </h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}